import { render, staticRenderFns } from "./ScoreBoard.vue?vue&type=template&id=7b5d3f44&scoped=true"
import script from "./ScoreBoard.vue?vue&type=script&lang=js"
export * from "./ScoreBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d3f44",
  null
  
)

export default component.exports